/**
 * @internal Intended for internal use - use it on your own risk
 */
export const DEFAULT_NOTIFICATIONS = {};
//# sourceMappingURL=model.js.map